module.exports = __webpack_public_path__ + "img/2-楼盘小程序-02.9da1b38e.png";